import React from 'react';
import PropTypes from 'prop-types';

const ModalNavigation = ({currentModalItemIndex, modalContentLength, language, setCurrentModalItemIndex}) => {

	const handleNextClick = () => {
		if (!setCurrentModalItemIndex) return;
		setCurrentModalItemIndex(prevIndex => {
			if (prevIndex < (modalContentLength - 1)) {
				return prevIndex + 1;
			}
			return prevIndex;
		});
	};

	const handlePrevClick = () => {
		if (!setCurrentModalItemIndex) return;
		setCurrentModalItemIndex(prevIndex => {
			if (prevIndex > 0) {
				return prevIndex - 1;
			}
			return prevIndex;
		});
	};

	const translateNavText = (text, language) => {
		if (language === 'fr-FR') {
			if (text.toLowerCase() === 'next') {
				return 'Afficher la page suivante';
			}

			if (text.toLowerCase() === 'previous') {
				return 'Afficher la page précédente';
			}

		}

		if (text.toLowerCase() === 'next') {
			return 'Next';
		}

		if (text.toLowerCase() === 'previous') {
			return 'Previous';
		}
	}

	return (
		<div className='modal__navigation'>
			<button className='modal__navigation--prev' type='button' onClick={handlePrevClick} disabled={currentModalItemIndex === 0}>{translateNavText('previous', language)}</button>
			<button className='modal__navigation--next' type='button' onClick={handleNextClick} disabled={currentModalItemIndex === (modalContentLength - 1)}>{translateNavText('next', language)}</button>
		</div>
	)
}

export default ModalNavigation;

ModalNavigation.propTypes = {
	currentModalItemIndex: PropTypes.number,
	modalContentLength: PropTypes.number,
	language: PropTypes.string,
	setCurrentModalItemIndex: PropTypes.func,
}